import { render, staticRenderFns } from "./publicTaskDlg.vue?vue&type=template&id=2d102e5a&scoped=true"
import script from "./publicTaskDlg.vue?vue&type=script&lang=js"
export * from "./publicTaskDlg.vue?vue&type=script&lang=js"
import style0 from "./publicTaskDlg.vue?vue&type=style&index=0&id=2d102e5a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d102e5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d102e5a')) {
      api.createRecord('2d102e5a', component.options)
    } else {
      api.reload('2d102e5a', component.options)
    }
    module.hot.accept("./publicTaskDlg.vue?vue&type=template&id=2d102e5a&scoped=true", function () {
      api.rerender('2d102e5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compliance/task/dialog/publicTaskDlg.vue"
export default component.exports